/**
An "Active" field is an input that either:
  - is focused, or
  - has a value
  
This is a utility to add a class to a parent element when an input is Active. 

== USAGE ==
const options = {
  inputSelector: 'input[type=email], select, textarea.contact__message',
  parentSelector: 'div.field',
  activeClass: 'field--withActiveIndicator'
};

ActiveFieldIndicator.init(options);

document.addEventListener('PT.activeElementIndicator.change', function(e) {
  console.log("Input 'Active' state changed: ", e.target);
  console.log("Element is now active? ", e.detail.isActive);
  console.log("Input parent is ", e.detail.parent);
});

document.addEventListener('PT.activeElementIndicator.active', function(e) { ... });
document.addEventListener('PT.activeElementIndicator.inactive', function(e) { ... });

===
// The input has a field indicator property that can be used to update it manually.
// Run after manually changing the focus, for instance:
const input = document.querySelector('.someInputWithAnActiveIndicator');
input['Plaintext.ActiveFieldIndicator'].update();
 */

window.Plaintext = (window.Plaintext || {});

function init(options) {
  document.querySelectorAll(options.inputSelector).forEach(input => {
    if (input['Plaintext.ActiveFieldIndicator']) { return; }
    const fnUpdate = () => handleInputUpdate(input, options);
    input['Plaintext.ActiveFieldIndicator'] = { update: fnUpdate };
  
    input.addEventListener('change', fnUpdate);
    input.addEventListener('focus', fnUpdate)
    input.addEventListener('blur', fnUpdate);
    fnUpdate();
  });
}

function handleInputUpdate(input, options) {
  const parentSelector = options.parentSelector;
  const parent = input.closest(parentSelector);
  
  if (!parent) { 
    console.error(`No parent ${ parentSelector } found for input`, input);
    return;
  }

  const activeClass = options.activeClass;
  
  if (!activeClass) {
    console.error(`No active class in options`, options);
    return;
  }
  
  const hasActiveValue = inputHasActiveValue(input);
  const parentClassList = parent.classList;
  const hasFocus = (document.activeElement === input);
  const isActive = (hasActiveValue || hasFocus);
  const isAlreadyActive = parentClassList.contains(activeClass);

  if (isActive && !isAlreadyActive) {
    parentClassList.add(activeClass);

    input.dispatchEvent(new CustomEvent('PT.ActiveFieldIndicator.active', {
      detail: { parent }, bubbles: true
    }));

    input.dispatchEvent(new CustomEvent('PT.ActiveFieldIndicator.change', {
      detail: { parent, isActive: true}, bubbles: true
    }));
  }
  else if (!isActive && isAlreadyActive) {
    parentClassList.remove(activeClass);

    input.dispatchEvent(new CustomEvent('PT.ActiveFieldIndicator.inactive', {
      detail: { parent }, bubbles: true
    }));

    input.dispatchEvent(new CustomEvent('PT.ActiveFieldIndicator.change', {
      detail: { parent, isActive: false}, bubbles: true
    }));
  }
}

function inputHasActiveValue(input) {
  // Select <option> tags can override being active with data-show-as-inactive
  if (input.tagName.toLowerCase() === 'select') {
    const selectedOption = input.selectedOptions[0];

    if (selectedOption.hasAttribute('data-show-as-inactive')) {
      return false;
    }
  }

  return !!input.value;
}

window.Plaintext.ActiveFieldIndicator = { init }
export default window.Plaintext.ActiveFieldIndicator; 
